import { Box, Col } from '@opendoor/atoms/box';
import { Image } from '@opendoor/atoms/image';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

import { type ListingDetails, listingPartnerFor, listingPhotoUrl } from './listingDetails';
import { ListingPartnerDetails } from './ListingPartnerDetails';

export const ListingInformation = ({ listing }: { listing: ListingDetails }) => {
  const photo = listingPhotoUrl(listing);
  const partner = listingPartnerFor(listing);

  return (
    <Col
      as="section"
      aria-label="Property information"
      className="min-w-0 gap-4 rounded-[16px] bg-od-bg-secondary p-4 lg:col-start-2 lg:row-start-1"
    >
      <Box
        className={cn(
          'h-[146px] w-full overflow-hidden rounded-[8px]',
          !photo && 'bg-od-bg-inactive-secondary',
        )}
      >
        {photo ? <Image src={photo} alt="" className="size-full object-cover" /> : null}
      </Box>
      <Text as="h2" className="font-medium text-[20px] tracking-[-0.28px] text-od-content-primary">
        {listing.address.humanReadable}
      </Text>
      <ListingPartnerDetails partner={partner} />
    </Col>
  );
};
